// Libs
import type React from "react";
import { useEffect } from "react";
import { useTranslation } from "src/design-system/core/TranslationContext";

// Components

// Utils
import { BiListUl, BiNotepad, BiSolidFileExport, BiStar, BiStats } from "react-icons/bi";
import { GoTag } from "react-icons/go";
import { RiMegaphoneLine } from "react-icons/ri";
import { ADMIN_ANALYZE_LAYOUT_TK } from "src/layouts/AdminAnalyzeLayout/config";
import type { NavBarSection } from "src/layouts/SharedLayout/NavBar";
import { SideMenuAWithNavBarLayout } from "src/layouts/SideMenuWithNavBarLayout/SideMenuWithNavBarLayout";
import { PATH_SUPERADMIN_ANALYZE } from "src/routesConstants";
import { VIEW_AS_ADMIN_LOCAL_PARAM } from "src/views/admin/AdminView/user/UserFormView/UserFormView.hook";
import { ADMIN_TRANSLATION_NAMESPACE } from "src/views/admin/config";

interface AdminAnalyzeLayoutProps {
    children?: React.ReactNode;
}

function AdminAnalyzeLayout(props: AdminAnalyzeLayoutProps): JSX.Element {
    const { t } = useTranslation(`${ADMIN_TRANSLATION_NAMESPACE}:${ADMIN_ANALYZE_LAYOUT_TK}`);

    useEffect(() => {
        localStorage.setItem(`flynt:${VIEW_AS_ADMIN_LOCAL_PARAM}`, "true");
    }, []);

    const sections: NavBarSection[] = [
        {
            items: [
                {
                    title: t("dashboard"),
                    icon: BiStats,
                    href: `${PATH_SUPERADMIN_ANALYZE}/dashboard`,
                },
                {
                    title: t("agenda"),
                    icon: BiNotepad,
                    href: `${PATH_SUPERADMIN_ANALYZE}/agenda?agenda-binder-status=error`,
                },
                {
                    title: t("offer-detail-view"),
                    icon: GoTag,
                    href: `${PATH_SUPERADMIN_ANALYZE}/detail/offer`,
                },
                {
                    title: t("sponsored-ad-detail-view"),
                    icon: RiMegaphoneLine,
                    href: `${PATH_SUPERADMIN_ANALYZE}/detail/sponsored-ad`,
                    disabled: true, // This page is not ready yet, we keep the link but disable it for now
                },
                {
                    title: t("ope-special"),
                    icon: BiStar,
                    href: `${PATH_SUPERADMIN_ANALYZE}/ope-special`,
                },
                {
                    title: t("platform-pos-list"),
                    icon: BiListUl,
                    href: `${PATH_SUPERADMIN_ANALYZE}/platform-pos-list`,
                },
                {
                    title: t("export-list"),
                    icon: BiSolidFileExport,
                    href: `${PATH_SUPERADMIN_ANALYZE}/export-list`,
                },
            ],
        },
    ];

    return (
        <SideMenuAWithNavBarLayout sections={sections}>{props.children}</SideMenuAWithNavBarLayout>
    );
}

export default AdminAnalyzeLayout;
